/* eslint-disable no-restricted-syntax */
import {ComponentProps, forwardRef} from 'react';
import {getTrackedOnClickEvent} from '@/components/tracked-atoms/get-tracked-onclick-event';
import {TrackingProps} from '@/components/tracked-atoms/types';
import {TrackingClickPrefix, TrackingModifierSuffix} from '@/services/analytics/analytics-types';

type Props = ComponentProps<'button'> & TrackingProps;

export const TrackedButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      trackingKey,
      trackingAs = TrackingClickPrefix.BTN,
      trackingText,
      trackingUseDisabledSuffix,
      trackingClickUrl,
      onClick,
      ...props
    },
    ref,
  ) => {
    const handleClick = getTrackedOnClickEvent<HTMLButtonElement>(trackingKey, onClick, (event, trackingKey) => ({
      click_as: trackingAs,
      click_action: trackingKey,
      click_modifier_suffix: trackingUseDisabledSuffix ? TrackingModifierSuffix.DISABLED : undefined,
      click_text: trackingText ?? (event.currentTarget.textContent?.trim() || ''),
      click_url: trackingClickUrl ?? null,
    }));

    return <button {...props} ref={ref} onClick={handleClick} />;
  },
);

TrackedButton.displayName = 'TrackedButton';
